import type { ProgressBarStatus } from "@financeable-com-au/financeable-ui";

const getProgressStatus = (fieldsPercentage: number): ProgressBarStatus => {
  switch (true) {
    case fieldsPercentage >= 75:
      return "green";
    case fieldsPercentage >= 50:
      return "yellow";
    case fieldsPercentage >= 25:
      return "orange";
    case fieldsPercentage >= 0:
    default:
      return "red";
  }
};

export { getProgressStatus };